import type { ReduxState } from './druid/types/internal/ReduxState';

export default ({ sendTypingIndicator }: ReduxState): boolean => sendTypingIndicator;
